import ApiService from "../api.services";
import { TokenService } from "../auth/storage.services";

const UserTypeEnum = Object.freeze({
  MASTER: "0",
  ADMIN: "1",
  CUSTOMER: "2",
  EMPLOYEE: "3"
});

class AuthenticationError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

class RequestError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const UserService = {
  login: async function(username, password) {
    const requestData = {
      username,
      password
    };

    try {
      const response = await ApiService.post("/auth/login", requestData);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new AuthenticationError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  me: async function() {
    try {
      const response = await ApiService.get("/auth/me");
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new AuthenticationError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  list: async function({ withCompanies = false, companyId = "" }) {
    let query = "?";
    if (withCompanies) query += "withCompanies=true";
    if (companyId.length > 0) query += `&companyId=${companyId}`;
    try {
      const response = await ApiService.get(`/users${query}`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  get: async function(id) {
    try {
      const response = await ApiService.get(`/users/${id}`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  add: async function(
    name,
    contact,
    mail,
    password,
    type,
    federalId,
    out,
    companyId
  ) {
    const data = {
      name,
      contact,
      mail,
      password,
      type,
      federalId,
      out,
      companyId
    };
    try {
      const response = await ApiService.post("/users", data);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  update: async function(id, name, contact, password, type, federalId, out) {
    const data = {
      user: {
        name,
        contact,
        type,
        password,
        federalId,
        out
      }
    };
    try {
      const response = await ApiService.put(`/users/${id}`, data);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  profile: async function(name, password, oldPassword) {
    const data = {
      user: {
        name,
        password,
        oldPassword
      }
    };
    try {
      const response = await ApiService.post(`/users/profile`, data);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  delete: async function(id) {
    try {
      const response = await ApiService.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  block: async function(id) {
    try {
      const response = await ApiService.put(`/users/block/${id}`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  unblock: async function(id) {
    try {
      const response = await ApiService.put(`/users/unblock/${id}`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  logout() {
    TokenService.removeToken();
    ApiService.removeHeader();
  },

  forgotPassword: async function(mail) {
    try {
      const data = { email: mail };
      const res = await ApiService.post("/users/forgot", data);
      return res.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  }
};

export default UserService;
export { UserService, AuthenticationError, UserTypeEnum, RequestError };
